import * as React from "react";
import { Container } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import _ from "lodash";
import { resolve, reject } from "q";
import moment from "moment";
import { ToastContainer, toast } from "react-toastify";
import EllipsisWithTooltip from "react-ellipsis-with-tooltip";
import { UserManagement } from "../../Common/Services/UserManagement";
import { Utils } from "../../Common/Utilis";

export class BookkeepingServices2FACodes extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            bkscodeList: [],
            isLoader: false,
        };
    }

    componentDidMount() {
        this.GetTwilioIncomingWebhookMessagesData();
    }

    GetTwilioIncomingWebhookMessagesData = () => {
        this.setState({ isLoader: true });
        UserManagement.GetTwilioIncomingWebhookMessagesData()
            .then(async (result: any) => {
                if (result.success) {
                    this.setState({ bkscodeList: result?.result, isLoader: false });
                } else {
                    Utils.toastError(result.message, {
                        position: toast.POSITION.BOTTOM_RIGHT,
                        containerId: "bks2facodes",
                    });
                }
                resolve();
            })
            .catch((error) => {
                Utils.toastError("Something went wrong.", {
                    position: toast.POSITION.BOTTOM_RIGHT,
                    containerId: "bks2facodes",
                });
                reject();
            });
    };

    copyToClipboard = (text) => {
        const textField = document.createElement("textarea");
        textField.innerText = text;
        document.body.appendChild(textField);
        textField.select();
        document.execCommand("copy");
        textField.remove();
        let message = "";
        message = "2-FA Code Copied to Your Clipboard";

        toast.success(message, {
            position: toast.POSITION.BOTTOM_RIGHT,
            containerId: "bks2facodes",
        });
    };

    dateFormatter = (cell: any, row: any, rowIndex: any) => {
        return (
            <div>
                {moment
                    .utc(row.date)
                    .tz("America/New_York")
                    .format("MM/DD/YYYY hh:mm A [EST]")}
            </div>
        );
    };

    codeFormatter = (cell: any, row: any, rowIndex: any) => {
        return (
            <>
                <div>
                    <div>{row.message}</div>
                    {/* <button className="icon"
                        onClick={() => this.copyToClipboard(row.code)}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="19" viewBox="0 0 21 19" fill="none">
                            <rect x="7.25" y="1.25" width="12.5" height="12.5" rx="1.75" fill="white" stroke="#0E9074" stroke-width="1.5" />
                            <rect x="1.25" y="6.25" width="12.5" height="11.5" rx="1.75" fill="white" stroke="#0E9074" stroke-width="1.5" />
                        </svg>
                    </button> */}
                </div>
            </>
        );
    };

    render() {
        const { bkscodeList, isLoader } = this.state;

        const columns = [
            {
                dataField: "date",
                text: "Date/Time",
                formatter: this.dateFormatter,
            },
            {
                dataField: "message",
                text: "Message",
                formatter: this.codeFormatter,
            },
        ];

        return (
            <Container fluid className="body-sec pms-import fa-coded-UI">
                {/* <ToastContainer
                    autoClose={3000}
                    containerId={"bks2facodes"}
                    enableMultiContainer
                /> */}
                <>
                    <div className="page-heading underline d-flex">
                        <div className="mr-auto d-flex align-items-center">
                            Bookkeeping Services - Incoming Messages
                        </div>
                    </div>
                    <div className="main-Page">
                        <div className="bdy-sec">
                            {!isLoader && (
                                <div>
                                    <BootstrapTable
                                        keyField="id"
                                        data={bkscodeList}
                                        columns={columns}
                                        noDataIndication="No data found"
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                </>
            </Container>
        );
    }
}
